import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { MobileVillageListPageContainer, VillageListPageContainer } from '../VillageListPage';
import { TReduxStore } from '../../types/store';
import { AppContext } from './AppContext';
import { IApplicationContext } from '../../types/application';
import * as styles from './App.css';
import { HelmetContainer } from '../HelmetContainer';
import { LocationDetectModalContainer } from '../LocationDetectModalModalContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export class Application extends React.Component<IApplicationProps> {
  public render() {
    const { context, reduxStore } = this.props;
    const {
      mobile: { isMobileVersion },
    } = reduxStore.getState();

    return (
      <ErrorLogComponent logger={context.logger}>
        <AppContext.Provider value={context}>
          <div className={styles['index']}>
            <Provider store={reduxStore}>
              <HelmetContainer />
              {isMobileVersion ? <MobileVillageListPageContainer /> : <VillageListPageContainer />}
              <LocationDetectModalContainer />
            </Provider>
          </div>
        </AppContext.Provider>
      </ErrorLogComponent>
    );
  }
}
